/**
 * Origem Flow: em navegadores MOBILE (qualquer navegador, qualquer OS —
 * Safari/Chrome no iPhone, Chrome/Firefox/Samsung no Android...), os pontos
 * de entrada do desktop ("/", dashboard e a página Início do workspace)
 * redirecionam para a casca mobile /m/* — a mesma experiência do app nativo.
 *
 * Detecção agnóstica de plataforma: viewport de celular E sinal de aparelho
 * touch (ponteiro grosso, toque ou user agent mobile). A exigência dupla
 * evita capturar uma janela estreita de desktop.
 *
 * Opt-out pelo cookie `origemflow-ui=desktop` (link "Usar a versão desktop"
 * na casca mobile). Só roda no cliente: decidir por User-Agent no SSR
 * quebraria deep links compartilhados.
 */
export default defineNuxtRouteMiddleware((to) => {
  if (import.meta.server) return
  const entryRoutes = ['index', 'dashboard', 'workspace', 'root']
  if (!entryRoutes.includes(to.name)) return
  if (document.cookie.includes('origemflow-ui=desktop')) return

  const smallViewport = window.matchMedia?.('(max-width: 768px)')?.matches
  if (!smallViewport) return
  const coarsePointer = window.matchMedia?.('(pointer: coarse)')?.matches
  const hasTouch = (navigator.maxTouchPoints ?? 0) > 0
  const mobileUa = /Android|iPhone|iPad|iPod|Mobile|Silk|Opera Mini/i.test(
    navigator.userAgent
  )
  if (!coarsePointer && !hasTouch && !mobileUa) return

  return navigateTo({ name: 'mobile-myday' }, { replace: true })
})
